$(document).on('click', '.js-branding', function (e) {
  if (e.target === this) {
    var url = $(this).data('url')
    if (url) {
      window.open(url, '_blank')
      return false
    }
  }
})

$(document).on('click', '.js-footer-branding, .js-header-branding', function () {
  $(this).closest('.js-branding').trigger('click')
  return false
})
